import { Skeleton } from 'antd';
import React from 'react';

interface Props {
  height: number;
}

const GeneratingImage = ({ height }: Props) => {
  return (
    <div className="relative border border-gray-300 rounded-lg">
      <Skeleton.Image
        className="ant-image-preview-img rounded-lg"
        style={{
          width: height * 1.5,
          height,
        }}
        active
      />
    </div>
  );
};

export default GeneratingImage;
